var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_leaveApplication_form_newTitle"),
      pad: "0",
      initData: _vm.ApplicationData,
      checkData: [
        "leave_reason_uuid",
        "leave_transaction_type_uuid",
        "remarks",
      ],
      widthClass: "max-1000",
      backgroundClass: "transparent",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: {
                curStep: _vm.curStep,
                items: _vm.stepper,
                contentClass: "pa-0 white",
              },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      !_vm.NoticeList ? _c("noContent") : _vm._e(),
                      _vm.NoticeList
                        ? _c(
                            "v-sheet",
                            { staticClass: "pa-8 rounded-t-lg" },
                            [
                              _c("span", { staticClass: "text-h4" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_myLeaveApplication_form_step_applicationNotesLabel"
                                    )
                                  )
                                ),
                              ]),
                              _vm.NoticeList.f1
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-list-item-icon", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "material-icons-round md-24",
                                          },
                                          [_vm._v("fiber_manual_record")]
                                        ),
                                      ]),
                                      _c(
                                        "v-list-item-content",
                                        { staticClass: "pl-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  _vm.NoticeList.f1
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.NoticeList.f2
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-list-item-icon", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "material-icons-round md-24",
                                          },
                                          [_vm._v("fiber_manual_record")]
                                        ),
                                      ]),
                                      _c(
                                        "v-list-item-content",
                                        { staticClass: "pl-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  _vm.NoticeList.f2
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.NoticeList.f3
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-list-item-icon", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "material-icons-round md-24",
                                          },
                                          [_vm._v("fiber_manual_record")]
                                        ),
                                      ]),
                                      _c(
                                        "v-list-item-content",
                                        { staticClass: "pl-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  _vm.NoticeList.f3
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.NoticeList.f4
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-list-item-icon", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "material-icons-round md-24",
                                          },
                                          [_vm._v("fiber_manual_record")]
                                        ),
                                      ]),
                                      _c(
                                        "v-list-item-content",
                                        { staticClass: "pl-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  _vm.NoticeList.f4
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _vm.CurleaveType
                        ? _c(
                            "v-card",
                            {
                              staticClass: "transparent pa-0",
                              attrs: { elevation: 0 },
                            },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "pa-0 mrc-grey" },
                                [
                                  false
                                    ? _c(
                                        "v-sheet",
                                        {
                                          staticClass:
                                            "pt-1 rounded rounded-b-lg",
                                          attrs: { color: "primary" },
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "elevation-0 mb-4 rounded-b",
                                              attrs: { tile: "" },
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass:
                                                    "\n                    d-flex\n                    flex-column\n                    justify-space-between\n                    pa-3\n                    white--text\n                  ",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-left text-h6 text--primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              _vm.CurleaveType[
                                                                "leave_type_name"
                                                              ]
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  Number(
                                                    _vm.CurleaveType[
                                                      "is_show_pending"
                                                    ]
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "\n                      text-right\n                      title\n                      text--primary\n                      d-flex\n                      align-center\n                      justify-end\n                    ",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline-block text-h2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.leaveBalance
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "d-inline-block text-caption mx-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .CurleaveType[
                                                                    "unit"
                                                                  ] === "D"
                                                                    ? _vm.$t(
                                                                        "label_essweb_system_dayLabel"
                                                                      )
                                                                    : _vm.$t(
                                                                        "label_essweb_system_hourLabel"
                                                                      )
                                                                ) + " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  Number(
                                                    _vm.CurleaveType[
                                                      "is_show_pending"
                                                    ]
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-right text-caption text--secondary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "label_essweb_myLeaveApplication_form_pendingLabel"
                                                                )
                                                              ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm
                                                                  .CurleaveType[
                                                                  "leave_pending"
                                                                ] +
                                                                  (_vm
                                                                    .CurleaveType[
                                                                    "unit"
                                                                  ] === "D"
                                                                    ? _vm.$t(
                                                                        "label_essweb_system_dayLabel"
                                                                      )
                                                                    : _vm.$t(
                                                                        "label_essweb_system_hourLabel"
                                                                      ))
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "rounded-t-lg white pa-8 mt-8",
                                    },
                                    [
                                      _c(
                                        "v-form",
                                        {
                                          ref: "form",
                                          attrs: { "lazy-validation": "" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "6",
                                                    md: 6,
                                                    lg: 6,
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("AutoComplete", {
                                                    attrs: {
                                                      label:
                                                        "label_essweb_leaveApplication_form_leaveTypeLabel",
                                                      items: _vm.leaveType,
                                                      rules: _vm.$GetRules(
                                                        ["_Require_Rules"],
                                                        [null]
                                                      ),
                                                      disabled: "",
                                                      "item-value":
                                                        "value_field",
                                                      "item-text":
                                                        "view_fields",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ApplicationData
                                                          .leave_type_uuid,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ApplicationData,
                                                          "leave_type_uuid",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ApplicationData.leave_type_uuid",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "6",
                                                    md: 6,
                                                    lg: 6,
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("AutoComplete", {
                                                    key:
                                                      _vm.defaultLang +
                                                      "--leave_transaction_type_uuid",
                                                    attrs: {
                                                      isRequired: "",
                                                      label:
                                                        "label_essweb_leaveApplication_form_leaveTransactionTypeLabel",
                                                      items:
                                                        _vm.leaveTransactionType,
                                                      rules: _vm.$GetRules(
                                                        ["_Require_Rules"],
                                                        [null]
                                                      ),
                                                      "item-value": "uuid",
                                                      "item-text":
                                                        "leave_transaction_type_name",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ApplicationData
                                                          .leave_transaction_type_uuid,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ApplicationData,
                                                          "leave_transaction_type_uuid",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ApplicationData.leave_transaction_type_uuid",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    xs: "12",
                                                    sm: "6",
                                                    md: "6",
                                                    lg: "6",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c("AutoComplete", {
                                                    attrs: {
                                                      isRequired: "",
                                                      label:
                                                        "label_essweb_leaveApplication_form_leaveReasonLabel",
                                                      items: _vm.leaveReason,
                                                      rules: _vm.$GetRules(
                                                        ["_Require_Rules"],
                                                        [null]
                                                      ),
                                                      "mrc-key":
                                                        _vm.defaultLang +
                                                        "--leave_reason_uuid",
                                                      "item-value":
                                                        "value_field",
                                                      "item-text":
                                                        "view_fields",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.ApplicationData
                                                          .leave_reason_uuid,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.ApplicationData,
                                                          "leave_reason_uuid",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ApplicationData.leave_reason_uuid",
                                                    },
                                                  }),
                                                  _vm.ApplicationData
                                                    .leave_reason_uuid ===
                                                  "other"
                                                    ? _c("v-text-field", {
                                                        attrs: {
                                                          filled: "",
                                                          dense: "",
                                                          placeholder: _vm.$t(
                                                            "label_essweb_LeaveApplication_form_fillReasonLabel"
                                                          ),
                                                          "single-line": "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.ApplicationData
                                                              .leave_reason_text,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.ApplicationData,
                                                              "leave_reason_text",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "ApplicationData.leave_reason_text",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  key: _vm.refreshKey,
                                                  attrs: {
                                                    sm: "6",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass:
                                                        "mrc_text_require text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_LeaveApplication_form_leaveTimeLabel"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.logic == -1
                                                    ? _c("DateTimePicker", {
                                                        attrs: {
                                                          isRequire: "",
                                                          disabled:
                                                            _vm.logic == -1,
                                                          url_type: "admin",
                                                          type: "onedatetimerange",
                                                          value:
                                                            _vm.dateTerminal,
                                                          defaultStartTime:
                                                            _vm.defaultStartDate,
                                                          defaultEndTime:
                                                            _vm.defaultEndDate,
                                                          placeholder: _vm.$t(
                                                            "label_essweb_RosterRecord_list_seTimeLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time,
                                                            isre
                                                          ) {
                                                            _vm.dateTerminal =
                                                              time
                                                            if (isre) {
                                                              _vm.defaultStartDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[0]
                                                                  : ""
                                                              _vm.defaultEndDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[1]
                                                                  : ""
                                                            }
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.logic == 4
                                                    ? _c("DateTimePicker", {
                                                        attrs: {
                                                          isRequire: "",
                                                          url_type: "admin",
                                                          type: "daterange",
                                                          value:
                                                            _vm.dateTerminal,
                                                          defaultStartTime:
                                                            _vm.defaultStartDate,
                                                          defaultEndTime:
                                                            _vm.defaultEndDate,
                                                          placeholder: _vm.$t(
                                                            "label_essweb_RosterRecord_list_seTimeLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time,
                                                            isre
                                                          ) {
                                                            _vm.dateTerminal =
                                                              time
                                                            if (isre) {
                                                              _vm.defaultStartDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[0]
                                                                  : ""
                                                              _vm.defaultEndDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[1]
                                                                  : ""
                                                            }
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.logic == 3
                                                    ? _c("DateTimePicker", {
                                                        attrs: {
                                                          isRequire: "",
                                                          type: "dateapm",
                                                          url_type: "admin",
                                                          value:
                                                            _vm.dateTerminal,
                                                          defaultStartTime:
                                                            _vm.defaultStartDate,
                                                          defaultEndTime:
                                                            _vm.defaultEndDate,
                                                          placeholder: _vm.$t(
                                                            "label_essweb_RosterRecord_list_seTimeLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time,
                                                            isre
                                                          ) {
                                                            _vm.dateTerminal =
                                                              time
                                                            if (isre) {
                                                              _vm.defaultStartDate =
                                                                time
                                                                  .split(
                                                                    " - "
                                                                  )[0]
                                                                  .split(" ")[0]
                                                              _vm.defaultEndDate =
                                                                time
                                                                  .split(
                                                                    " - "
                                                                  )[1]
                                                                  .split(" ")[0]
                                                            }
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.logic == 1
                                                    ? _c("DateTimePicker", {
                                                        attrs: {
                                                          isRequire: "",
                                                          staff_uuid:
                                                            _vm.page_params
                                                              .staff_uuid,
                                                          "leave-transaction-type-code":
                                                            _vm.ApplicationData
                                                              .leave_transaction_type_code,
                                                          url_type: "admin",
                                                          type: "day30min",
                                                          TimeType: Number(
                                                            _vm.propertys[
                                                              "is_allow_apply|is_apply_as_n_minutes"
                                                            ]["value"]
                                                          ),
                                                          startTime: 0,
                                                          endTime: 1440,
                                                          value:
                                                            _vm.dateTerminal,
                                                          defaultStartTime:
                                                            _vm.defaultStartDate,
                                                          defaultEndTime:
                                                            _vm.defaultEndDate,
                                                          placeholder: _vm.$t(
                                                            "label_essweb_RosterRecord_list_seTimeLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time,
                                                            isre
                                                          ) {
                                                            _vm.dateTerminal =
                                                              time
                                                            if (isre) {
                                                              _vm.defaultStartDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[0]
                                                                  : ""
                                                              _vm.defaultEndDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[1]
                                                                  : ""
                                                            }
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.logic == 2
                                                    ? _c("DateTimePicker", {
                                                        attrs: {
                                                          isRequire: "",
                                                          url_type: "admin",
                                                          type: "daytime",
                                                          staff_uuid:
                                                            _vm.page_params
                                                              .staff_uuid,
                                                          "leave-transaction-type-code":
                                                            _vm.ApplicationData
                                                              .leave_transaction_type_code,
                                                          value:
                                                            _vm.dateTerminal,
                                                          defaultStartTime:
                                                            _vm.defaultStartDate,
                                                          defaultEndTime:
                                                            _vm.defaultEndDate,
                                                          placeholder: _vm.$t(
                                                            "label_essweb_RosterRecord_list_seTimeLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time,
                                                            isre
                                                          ) {
                                                            _vm.dateTerminal =
                                                              time
                                                            if (isre) {
                                                              _vm.defaultStartDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[0]
                                                                  : ""
                                                              _vm.defaultEndDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[1]
                                                                  : ""
                                                            }
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _vm.logic == 0
                                                    ? _c("DateTimePicker", {
                                                        attrs: {
                                                          isRequire: "",
                                                          url_type: "admin",
                                                          type: "day15min",
                                                          TimeType: Number(
                                                            _vm.propertys[
                                                              "is_allow_apply|is_apply_as_frontend_unit_as_minutes"
                                                            ]["value"]
                                                          ),
                                                          startTime: 0,
                                                          staff_uuid:
                                                            _vm.page_params
                                                              .staff_uuid,
                                                          "leave-transaction-type-code":
                                                            _vm.ApplicationData
                                                              .leave_transaction_type_code,
                                                          endTime: 1440,
                                                          value:
                                                            _vm.dateTerminal,
                                                          defaultStartTime:
                                                            _vm.defaultStartDate,
                                                          defaultEndTime:
                                                            _vm.defaultEndDate,
                                                          placeholder: _vm.$t(
                                                            "label_essweb_RosterRecord_list_seTimeLabel"
                                                          ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            time,
                                                            isre
                                                          ) {
                                                            _vm.dateTerminal =
                                                              time
                                                            if (isre) {
                                                              _vm.defaultStartDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[0]
                                                                  : ""
                                                              _vm.defaultEndDate =
                                                                time
                                                                  ? time.split(
                                                                      " - "
                                                                    )[1]
                                                                  : ""
                                                            }
                                                          },
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  key: _vm.refreshKey2,
                                                  attrs: {
                                                    sm: "6",
                                                    cols: "12",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass:
                                                        "text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_LeaveApplication_form_applyAsLabel"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      filled: "",
                                                      disabled: "",
                                                      dense: "",
                                                      "single-line": "",
                                                      value: _vm._f(
                                                        "getCostTime"
                                                      )(
                                                        _vm.ApplicationData
                                                          .showTime,
                                                        _vm.getCostTime2
                                                      ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    sm: "6",
                                                    cols: "12",
                                                    md: "6",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-sheet",
                                                    {
                                                      staticClass:
                                                        "text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_leaveApplication_form_attachmentLabel"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c("ImgDragUpdate", {
                                                    on: {
                                                      change: _vm.onInputImage,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: {
                    submitBtn:
                      _vm.step == _vm.curStep && _vm.curStep != 0
                        ? true
                        : false,
                    step: _vm.step == _vm.curStep ? false : true,
                    onLoading: _vm.isLoading,
                    preStep: _vm.curStep > 1 ? true : false,
                  },
                  on: {
                    next: _vm.toNext,
                    submit: function ($event) {
                      return _vm.toNew()
                    },
                    pre: function ($event) {
                      _vm.curStep = _vm.curStep - 1
                    },
                    cancel: function ($event) {
                      return _vm.$toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }